// Lazy load function
const lazyLoad = (file) => () =>
  import(
    /* webpackChunkName: "[request]" */ `@/views/demand-planning/mrp/${file}.vue`
  );

export default [
  {
    path: "/mrp",
    name: "mrp-list",
    meta: { requiresAuth: true, applicationFeatureCode: "MRP" },
    components: {
      content: lazyLoad("mrp-list"),
    },
  },
  {
    path: "/mrp/create",
    name: "mrp-create",
    meta: { requiresAuth: true, applicationFeatureCode: "MRP" },
    components: {
      content: lazyLoad("mrp"),
    },
  },
  {
    path: "/mrp/review/:id",
    name: "mrp-review",
    meta: { requiresAuth: true, applicationFeatureCode: "MRP" },
    components: {
      content: lazyLoad("mrp"),
    },
  },
];
